import { QueryClient, useQuery } from 'react-query';
import { fetchPageView, PageViewPlatform } from '@sls-react/api/tiles';
import { NextPageContext } from 'next';
import { minutes30inMS } from '../constants/times';
import useMobile from '@sls-react/hooks/useMobile';

export function prefetchPageViewById(
  id: number,
  queryClient: QueryClient,
  ctx?: NextPageContext,
) {
  return queryClient.fetchQuery(
    ['page-views', id],
    () =>
      fetchPageView.call(ctx, id, ctx?.device === 'mobile' ? 'mobile' : 'web'),
    {
      staleTime: minutes30inMS,
    },
  );
}

export default function usePageView(id: number) {
  const mobile = useMobile();
  return useQuery(
    ['page-views', id],
    () => fetchPageView(id, mobile ? 'mobile' : 'web'),
    {
      staleTime: 30000,
    },
  );
}

export function usePageViewCustomPlatform(
  id: number,
  platform?: PageViewPlatform,
) {
  const mobile = useMobile();
  return useQuery(
    ['page-views', id, platform],
    () => fetchPageView(id, platform ?? (mobile ? 'mobile' : 'web')),
    {
      staleTime: 30000,
    },
  );
}
